import * as React from "react";

interface GenBooleanCircleProps {
  value: boolean
}

export default function GenBooleanCircle(props: GenBooleanCircleProps) {
  const {
    value,
  } = props;

  return (
    value
      ? <i className="fa fa-circle-check boolean-check" />
      : <i className="fa fa-circle-xmark boolean-times" />
  );
}
